export default __webpack_public_path__ + "static/media/LookOthers2.2e254aaf.png";